/**
 * Plain-text preview for HTML template fields (section/child labels in tables).
 */

export function stripHtmlToPreview(html: string | undefined, maxLen = 72): string {
  if (!html || !String(html).trim()) return '—'
  const text = String(html)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  if (!text) return '—'
  return text.length <= maxLen ? text : `${text.slice(0, maxLen)}…`
}
